// 导入要使用的 scss颜色变量
import {
  blueColor,
  cyanblueColor,
  purpleColor,
  grayColor,
  lightGreen,
  lightGray,
  redColor
} from '@/style/var.scss'

/*
    产品草稿/功能类型
    service: 服务
    property: 属性
    event: 事件
*/
export const functionTypeTag = {
  service: {
    backgroundColor: cyanblueColor
  },
  property: {
    backgroundColor: purpleColor
  },
  event: {
    backgroundColor: blueColor
  }
}

/*
    产品种类
    gateway: 网关
    direct: 直连设备
    child: 子设备
*/
export const productTypeTag = {
  gateway: {
    borderColor: purpleColor,
    color: purpleColor
  },
  direct: {
    borderColor: blueColor,
    color: blueColor
  },
  child: {
    borderColor: blueColor,
    color: blueColor
  },
  steamingOven: {
    borderColor: blueColor,
    color: blueColor
  },
  refrigerator: {
    borderColor: blueColor,
    color: blueColor
  }
}

/*
    上下线动作
    true: 上线
    false: 下线
*/
export const onOffLineTag = {
  [true]: {
    backgroundColor: blueColor
  },
  [false]: {
    backgroundColor: grayColor
  }
}

/*
    菜谱状态
    Y: 已发布
    N: 未发布
*/
export const publishStatusTag = {
  Y: {
    backgroundColor: lightGreen,
    borderColor: lightGreen,
    color: '#5BC49F'
  },
  N: {
    backgroundColor: lightGray,
    borderColor: lightGray,
    color: '#666666'
  }
}

/*
    设备在/过保状态
    Y: 在保
    N: 过保
    U:未登记
*/
export const limitTimeStatusTag = {
  Y: {
    backgroundColor: lightGreen,
    borderColor: lightGreen,
    color: '#5BC49F'
  },
  N: {
    backgroundColor: 'rgba(255,123,123,0.15)',
    borderColor: 'rgba(255,123,123,0.15)',
    color: '#EC6161'
  },
  U: {
    backgroundColor: lightGray,
    borderColor: lightGray,
    color: '#666666'
  }
}

/*
    设备在/过保状态
    Y: 在保
    N: 过保
    U:未登记
*/
export const iceDeviceStatusTag = {
  [0]: {
    backgroundColor: 'rgba(255,123,123,0.15)',
    borderColor: 'rgba(255,123,123,0.15)',
    color: '#EC6161'
  },
  [1]: {
    backgroundColor: 'rgba(83,156,255,0.15)',
    borderColor: 'rgba(83,156,255,0.15)',
    color: '#339DFF'
  }
}
